import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const names = ['María', 'Laura', 'Florencia', 'Agustina', 'Camila', 'Lucía', 'Paula', 'Martina', 'Julieta', 'Sofía', 'Micaela', 'Carolina'];
const lastNames = ['González', 'Rodríguez', 'Fernández', 'López', 'Martínez', 'Pérez', 'Gómez', 'Sánchez', 'Romero', 'Sosa', 'Acosta', 'Benítez'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Santa Fe', 'Neuquén'];
export const SocialProofToast = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      showRandomToast();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showRandomToast = () => {
    const randomName = names[Math.floor(Math.random() * names.length)];
    const randomLastName = lastNames[Math.floor(Math.random() * lastNames.length)];
    const randomCity = cities[Math.floor(Math.random() * cities.length)];
    setCurrentData({
      name: `${randomName} ${randomLastName}`,
      city: randomCity
    });
    setIsVisible(true);
    // Hide after 5 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next popup between 15 and 30 seconds
      const nextDelay = Math.floor(Math.random() * (30000 - 15000 + 1) + 15000);
      setTimeout(showRandomToast, nextDelay);
    }, 5000);
  };
  return <AnimatePresence data-id="element-117">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-6 left-6 z-50 w-80 bg-white rounded-lg shadow-2xl border border-gray-100 overflow-hidden" data-id="element-118">
          <div className="bg-green-600 text-white text-[10px] font-bold tracking-wider px-3 py-1.5 flex items-center gap-1.5 uppercase" data-id="element-119">
            <CheckCircle className="w-3 h-3" data-id="element-120" />
            Compra Verificada
          </div>
          <div className="p-4 flex items-center gap-4" data-id="element-121">
            <div className="w-12 h-12 rounded-full bg-brand-teal/10 flex items-center justify-center flex-shrink-0" data-id="element-122">
              <img src="https://cdn.magicpatterns.com/uploads/41iNk4rdC7HqUpZkoQWoFn/Diseno_sin_titulo_(36).png" alt="Product thumb" className="w-8 h-8 object-contain" data-id="element-123" />
            </div>
            <div data-id="element-124">
              <p className="text-sm text-gray-800 leading-tight" data-id="element-125">
                <span className="font-bold" data-id="element-126">{currentData.name}</span> de{' '}
                {currentData.city} ha comprado el KIT Psicología en TCA.
              </p>
              <p className="text-xs text-gray-400 mt-1" data-id="element-127">Hace unos minutos</p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
};